<template>
    <div class="trade-dialog" :style="dialogStyle">
        <div class="header">
            <p class="title">{{title}}</p>
            <p class="close-icon" v-on:click="closeClick">
                <img :src="closeIcon" />
            </p>
        </div>
        <div class="content">
            <div class="step" v-if="currentStep == 0">
                <div class="select-list">
                    <ui-select :title="accountTitle" :model="accountModel" :options="tradeAccounts" :select-style="selectStyle" :font-style="fontStyle" @change-select="changeTradeAccount" :list-style="listStyle" :list-item-style="listItemStyle"></ui-select>
                </div>
                <p class="trade-item">
                    <span class="title">交易品种</span>
                    <span class="name">{{tradeInfo.name}}</span>
                </p>
                <p class="trade-item">
                    <span class="title">交易方向</span>
                    <span class="name">{{tradeInfo.cmd}}</span>
                </p>
                <!-- <p class="trade-item">
                    <span class="title">当前价格</span>
                    <span class="name">{{tradeInfo.openPrice}}</span>
                </p> -->
                <div class="select-list">
                    <ui-select :title="methodTitle" :model="methodModel" :options="methods" :select-style="selectStyle" :font-style="fontStyle" @change-select="changeCommissionMethod" :list-style="listStyle" :list-item-style="listItemStyle"></ui-select>
                </div>
                <div class="input">
                    <ui-input :title="volumeTitle" :font-style="fontStyle" :input-style="inputStyle" @change-input="changeTradeVolume" :model="tradeVolume"></ui-input>
                    <p class="msg" v-if="showMsgErr">{{volumeErr}}</p>
                </div>
                <div class="btn">
                    <button v-on:click="confirmClick">确定</button>
                </div>
            </div>
            <div class="step" v-if="currentStep == 1">
                <p class="warn-msg">以下是您的交易信息，请确认:</p>
                <p class="trade-item">
                    <span class="title">交易账户</span>
                    <span class="name">
                        {{tradeInfo.accountNo}}
                        <span class="type" v-if="parseInt(tradeInfo.accountType) == 1">(虚拟账户)</span>
                        <span class="type" v-if="parseInt(tradeInfo.accountType) == 2">(真实账户)</span>
                    </span>
                </p>
                <p class="trade-item">
                    <span class="title">交易品种</span>
                    <span class="name">{{tradeInfo.name}}</span>
                </p>
                <p class="trade-item">
                    <span class="title">交易方向</span>
                    <span class="name">{{tradeInfo.cmd}}</span>
                </p>
                <p class="trade-item">
                    <span class="title">委托方式</span>
                    <span class="name">{{commissionMethod}}</span>
                </p>
                <p class="trade-item">
                    <span class="title">委托手数</span>
                    <span class="name">{{tradeVolume}}</span>
                </p>
                <div class="btn">
                    <button v-on:click="secondStepConfirm">确定</button>

                </div>
            </div>
            <div class="step" v-if="currentStep == 2">
                <div class="step-content show-loading" v-if="showLoading">
                    <loading></loading>
                </div>
                <div class="step-content" v-if="orderSuccess && !showLoading">
                    <img class="icon" :src="successIcon" />
                    <p class="msg">下单成功</p>
                    <button class="scan-trade" v-on:click="scanMyTrade">查看我的交易</button>
                </div>
                <div class="step-content" v-if="!orderSuccess && !showLoading">
                    <img class="icon" :src="failIcon" />
                    <p class="msg">下单失败</p>
                    <p class="fail-info">失败原因:{{failMsg}}</p>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import closeIcon from '../../../static/img/ucenter/close_icon.png'
import successIcon from '../../../static/img/ucenter/order_success.png'
import failIcon from '../../../static/img/ucenter/order_fail.png'
import UiSelect from 'select'
import UiInput from 'input'
import Datas from 'ucenterDatas'
import API from 'ucenterApi'
import messageCenter from 'message.center'
import Loading from 'loading'
import reg from 'reg'
export default {
    components:{
        UiSelect,
        UiInput,
        Loading
    },
    data: function() {
        return {
            closeIcon: closeIcon,
            successIcon: successIcon,
            failIcon: failIcon,
            tradeAccounts: [],
            selectStyle:{
                'width': '270px',
                'height': '38px',
                'margin-left': '33px',
                'background-position': '94% 14px',
                'background-color': '#f8f8f8',
                'padding-left': '24px',
                'color': '#666',
                'font-size': '16px',
                'padding-top': '8px'
            },
            fontStyle: {
                'color': '#666',
                'font-size': '16px'
            },
            listStyle:{
                'width': '270px',
                'top': '38px',
                'left': '97px'

            },
            listItemStyle:{
                'width': '270px',
                'height': '34px',
                'line-height': '34px'
            },
            inputStyle:{
                'width': '270px',
                'height': '38px',
                'margin-left': '33px',
                'padding-left': '24px',
                'color': '#666',
                'font-size': '16px'
            },
            accountTitle: '交易账户',
            methodTitle: '委托方式',
            volumeTitle: '委托手数',
            methods: Datas.commissionMethods,
            accountModel:'',
            methodModel:'',
            tradeVolume: '',
            currentStep: 0,
            volumeErr: '',
            showMsgErr: false,
            orderSuccess: false,
            failMsg: '',
            showLoading: false

        }

    },
    props:{
        title:{
            type: String,
            default: '提示'
        },
        msg: {
            type: String,
            default: ''
        },
        cancelTitle:{
            type: String,
            default: '取消'
        },
        confirmTitle:{
            type: String,
            default: '确定'
        },
        dialogStyle:{
            type: Object,
            default: {}
        },
        cancelStyle:{
            type: Object,
            default: {}
        },
        confirmStyle:{
            type: Object,
            default: {}
        },
        tradeInfo:{
            type: Object,
            default: {}
        },
        tradeAccounts:{
            type: Array,
            default: []
        },
        cmd:{
            type: Number,
            default: 0
        },
        isUcenter: {
            type: Boolean,
            default: false
        }
    },
    created: function() {
        this.initAccounts();
        this.accountModel = this.tradeAccounts[0].accountNo;
        this.methodModel = this.methods[0].key;
        this.account = this.tradeAccounts[0].accountNo;
        this.method = this.methods[0].value;
        this.commissionMethod = this.methods[0].key;
    },
    mounted: function() {
        let cmd = this.tradeInfo.cmd;
        if (cmd == '买入'){
            messageCenter.onChangeBuyPrice((price, symbol)=>{
                if (this.tradeInfo.symbol == symbol){
                    this.tradeInfo.openPrice = price;
                }

            })
        }else if (cmd == '卖出'){
            messageCenter.onChangeSoldPrice((price, symbol)=>{
                if (this.tradeInfo.symbol == symbol){
                    this.tradeInfo.openPrice = price;
                }

            })
        }

    },
    methods:{
        // 初始化账户列表
        initAccounts: function(){

            let arr = this.tradeAccounts;
            arr.forEach((item) =>{
                let type = parseInt(item.accountType) == 1 ? '虚拟账户' : '真实账户';
                item.key = item.accountNo + '(' + type + ')';
                item.value = item.accountNo;
            })
            this.tradeAccounts = arr;

        },
        // 关闭弹窗
        closeClick: function(){
            this.$emit('close-click');
        },
        // 改变委托方式
        changeCommissionMethod: function(item){
            this.methodModel = item.key;
            this.method = item.value;
        },
        // 改变交易账户
        changeTradeAccount: function(item){
            this.accountModel = item.key;
            this.account = item.value;
            this.tradeInfo.accountNo = this.account;
            this.tradeInfo.accountModel = this.accountModel;
            this.tradeInfo.accountType = item.accountType;
        },
        // 改变委托手数
        changeTradeVolume: function(val){
            this.tradeVolume = val;
            this.tradeInfo.volume = val;
        },
        // 第一步确定
        confirmClick: function(){
            if (this.tradeVolume == '' || reg.emptyContentReg(this.tradeVolume) || this.tradeVolume.replace(/(^s*)|(s*$)/g, "").length == 0){
                this.showMsgErr = true;
                this.volumeErr = '请输入下单手数';
            }else if (parseFloat(this.tradeVolume) < 0.01 || !reg.numCodeReg(this.tradeVolume)){
                this.showMsgErr = true;
                this.volumeErr = '请输入不小于0.01的下单手数';
            }else {
                this.currentStep = 1;
                this.showMsgErr = false;
            }
        },
        // 第二步确定
        secondStepConfirm: function(){
            let params = {
                accountNo: this.tradeInfo.accountNo,
                accountType: this.tradeInfo.accountType,
                cmd: this.tradeInfo.cmd == '买入' ? '0' : '1',
                openPrice: this.tradeInfo.openPrice,
                symbol: this.tradeInfo.symbol,
                volume: this.tradeVolume
            };
            let self = this;
            self.currentStep = 2;
            self.showLoading = true;
            API.openOrder(params).then((data)=>{
                let res = data.data;
                if (res.header.code == 1){
                    self.currentStep = 2;
                    self.orderSuccess = true;
                    self.showLoading = false;
                }else if (res.header.code == 0){
                    self.currentStep = 2;
                    self.orderSuccess = false;
                    self.showLoading = false;
                    self.failMsg = res.header.msg;
                }

            }).catch((err)=>{

            })

        },
        // 查看我的交易
        scanMyTrade: function(){
            if (this.isUcenter){
                this.$router.push('/myTrade');
            }else {
                window.open(window.PAGE_DATA.commonData.myTradePath || '');
            }


        }

    }
}
</script>
<style lang="scss" scoped>
    .trade-dialog{
        width: 526px;
        border-radius: 10px;
        position: fixed;
        z-index: 100;
        left: 38%;
        top: 22%;
        .header{
            position: relative;
            background: #F5F5F5;
            border-radius: 10px 10px 0 0;
            height: 50px;
            line-height: 50px;
            padding-left: 26px;
            padding-right: 18px;
            .title{
                float: left;
                font-size: 16px;
                color: #666666;
            }
            .close-icon{
                float: right;
                width: 10px;
                height: 10px;

            }
            &:after{
                position: absolute;
                left: 0px;
                right: 0px;
                bottom: 0px;
                border-bottom: 1px solid #dadada;
            }
        }
        .content{
            background-color: #fff;
            padding: 32px 54px 54px 43px;
            border-radius: 0 0 10px 10px;
            .step{
                .warn-msg{
                    position: relative;
                    font-size: 16px;
                    color: #BC9B64;
                    height: 30px;
                    line-height: 12px;
                    &:after{
                        content: '';
                        position: absolute;
                        left: 0px;
                        right: 0px;
                        bottom: 0px;
                        border-bottom: 1px solid #dadada;
                    }

                }
                .trade-item{
                    clear: both;
                    padding-top: 30px;
                    font-size: 16px;
                    color: #666666;
                    .name{
                        padding-left: 33px;
                        .type {
                            font-size: 12px;
                            color: #999999;
                        }
                    }
                }
                .select-list{
                    margin-top: 30px;
                    &:first-child{
                        margin-top: 0px;
                    }
                }
                .input {
                    padding-top: 66px;
                    .msg {
                        float: left;
                        color: #CE2E2E;
                        font-size: 12px;
                        margin-top: 10px;
                        margin-left: 98px;
                    }
                }
                .btn{
                    margin-top: 45px;
                    text-align: center;
                    button {
                        width: 132px;
                        height: 34px;
                        background: #364983;
                        border-radius: 4px;
                        line-height: 34px;
                        text-align: center;
                        font-size: 14px;
                        color: #FFFFFF;
                        &:hover{
                            border: 1px solid #364983;
                            color: #364983;
                            background: none;
                        }
                    }
                }
                .step-content{
                    margin-top: 43px;
                    text-align: center;
                    &.show-loading {
                        margin-top: 83px;
                        height: 200px;
                    }
                    .icon{
                        width: 112px;
                        height: 112px;
                    }
                    .msg{
                        margin-top: 24px;
                        font-size: 14px;
                        color: #666666;
                    }
                    .fail-info{
                        margin-top: 58px;
                        font-size: 16px;
                        color: #333333;
                    }
                    .scan-trade{
                        margin-top: 54px;
                        width: 190px;
                        height: 42px;
                        border-radius: 4px;
                        border: 1px solid #364983;
                        font-size: 14px;
                        color: #364983;
                        &:hover{
                            // border: 1px solid #364983;
                            color: #fff;
                            background-color: #364983;
                        }

                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/tradeDialog.vue